<ion-app>
  <ion-router-outlet [animated]="false"></ion-router-outlet>
</ion-app>
<div
  *ngIf="envName"
  class="env-label"
>
  {{ envName | uppercase }}
</div>
